import React from 'react';
import { List as ListNew } from './List';
import { convertOldListProps } from './converter.old';
import type { OldListProps } from './converter.old';

export type ListProps<T extends string = string> = OldListProps<T>;

export const List = <T extends string>(props: ListProps<T>) => <ListNew {...convertOldListProps(props)} />;
